"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Weekdays = exports.ExpiringContractSendoutsSchedule = exports.Priority = exports.NotificationLanguage = exports.NotificationSettingMode = exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["deadlineBid"] = "DEADLINE_BID";
    NotificationType["deadlineTasks"] = "DEADLINE_TASKS";
    NotificationType["assignedToTasks"] = "ASSIGNED_TO_TASKS";
    NotificationType["assignedToBidTasks"] = "ASSIGNED_TO_BID_TASKS";
    NotificationType["assignedToBid"] = "ASSIGNED_TO_BID";
    NotificationType["assignedToTender"] = "ASSIGNED_TO_TENDER";
    NotificationType["assignedToMp"] = "ASSIGNED_TO_MP";
    NotificationType["assignedToWorkspace"] = "ASSIGNED_TO_WORKSPACE";
    NotificationType["assignedToContent"] = "ASSIGNED_TO_CONTENT";
    NotificationType["changeInMp"] = "CHANGE_IN_MP";
    NotificationType["changeInTask"] = "CHANGE_IN_TASK";
    NotificationType["taggedInComment"] = "TAGGED_IN_COMMENT";
    NotificationType["commentInThread"] = "COMMENT_IN_THREAD";
    NotificationType["statusChangeInProgress"] = "STATUS_CHANGE_IN_PROGRESS";
    NotificationType["statusChangeFinished"] = "STATUS_CHANGE_FINISHED";
    NotificationType["mpDailySendout"] = "MP_DAILY_SENDOUT";
    NotificationType["tenderUpdate"] = "TENDER_UPDATE";
    NotificationType["reminder"] = "REMINDER";
    NotificationType["expiringContractsSendout"] = "EXPIRING_CONTRACTS_SENDOUT";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var NotificationSettingMode;
(function (NotificationSettingMode) {
    NotificationSettingMode["InApp"] = "InApp";
    NotificationSettingMode["Email"] = "Email";
})(NotificationSettingMode = exports.NotificationSettingMode || (exports.NotificationSettingMode = {}));
var NotificationLanguage;
(function (NotificationLanguage) {
    NotificationLanguage["en"] = "en";
    NotificationLanguage["sv"] = "sv";
    NotificationLanguage["fi"] = "fi";
    NotificationLanguage["no"] = "no";
    NotificationLanguage["dk"] = "dk";
})(NotificationLanguage = exports.NotificationLanguage || (exports.NotificationLanguage = {}));
var Priority;
(function (Priority) {
    Priority[Priority["Highest"] = 5] = "Highest";
    Priority[Priority["High"] = 4] = "High";
    Priority[Priority["Normal"] = 3] = "Normal";
    Priority[Priority["Low"] = 2] = "Low";
    Priority[Priority["Lowest"] = 1] = "Lowest";
})(Priority = exports.Priority || (exports.Priority = {}));
(function (NotificationType) {
    NotificationType["Information"] = "Information";
    NotificationType["Warning"] = "Warning";
    NotificationType["PaymentError"] = "PaymentError";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var ExpiringContractSendoutsSchedule;
(function (ExpiringContractSendoutsSchedule) {
    ExpiringContractSendoutsSchedule["Daily"] = "Daily";
    ExpiringContractSendoutsSchedule["Monday"] = "Monday";
    ExpiringContractSendoutsSchedule["Tuesday"] = "Tuesday";
    ExpiringContractSendoutsSchedule["Wednesday"] = "Wednesday";
    ExpiringContractSendoutsSchedule["Thursday"] = "Thursday";
    ExpiringContractSendoutsSchedule["Friday"] = "Friday";
    ExpiringContractSendoutsSchedule["Saturday"] = "Saturday";
    ExpiringContractSendoutsSchedule["Sunday"] = "Sunday";
})(ExpiringContractSendoutsSchedule = exports.ExpiringContractSendoutsSchedule || (exports.ExpiringContractSendoutsSchedule = {}));
var Weekdays;
(function (Weekdays) {
    Weekdays["Monday"] = "Monday";
    Weekdays["Tuesday"] = "Tuesday";
    Weekdays["Wednesday"] = "Wednesday";
    Weekdays["Thursday"] = "Thursday";
    Weekdays["Friday"] = "Friday";
})(Weekdays = exports.Weekdays || (exports.Weekdays = {}));
